
class SelectorVariants extends HTMLElement {
    constructor() {
        super();
        this.form = this.closest('form')
        this.addEventListener('change', this.onVariantChange);
    }
    onVariantChange(event) {
        this.currentVariant = event.target.value
        this.updateMasterId()
        this.updateURL();
        this.renderProductInfo();
    }
    updateMasterId() {
        this.form.querySelector('.add-to-cart').setAttribute('data-variant-id', this.currentVariant)
    }
    updateURL(){
        const url = new URL(window.location);
        url.searchParams.set('variant', this.currentVariant);
        window.history.pushState(null, '', url.toString());
    }

    async renderProductInfo(){
        try{
            const response = await (await fetch(window.location.href + '&section_id=product-template')).text()
            const responseMarkup = new DOMParser().parseFromString(response, 'text/html')
            document.querySelector('[data-price-container]').innerHTML = responseMarkup.querySelector('[data-price-container]').innerHTML

            /* NDK: also update hidden price container used by ATC button sync */
            var hiddenPrice = document.getElementById('price-product-template')
            var newHiddenPrice = responseMarkup.getElementById('price-product-template')
            if (hiddenPrice && newHiddenPrice) {
                hiddenPrice.innerHTML = newHiddenPrice.innerHTML
            }

            document.dispatchEvent(new CustomEvent('changed_variant', {
                    bubbles: true,
                    detail: {
                        section: this.form
                    }
                }));

        }catch (error) {
            console.error(error)
        }
    }

}
customElements.define('selector-variants', SelectorVariants);


class DiscountCoupon{
    constructor() {
        const templateEl = document.querySelector("#couponMarkupPatterns")
        if (!templateEl?.content?.children?.length) return
        const [price, savingCoupon, savingBadge] = templateEl.content.children
        this.markupPatterns = {
            price: price,
            savingCoupon: savingCoupon,
            savingBadge: savingBadge
        }

        this.discountCode = this.getCookie("discount_code")

        if(!this.discountCode){
            this.discountCode = localStorage.getItem("coupon")
        }

        if(!this.discountCode) return;

        localStorage.setItem("coupon", this.discountCode)

        this.getDiscount()
    }

    /**
     * _parseCartDiscount – extract discountData from a cart object.
     * Returns the discountData object or null if it cannot be determined.
     */
    _parseCartDiscount(cart) {
        if (!cart.cart_level_discount_applications?.length) return null
        const disc = cart.cart_level_discount_applications[0]
        const discAmount = disc.total_allocated_amount || 0
        const itemsSubtotal = cart.items.reduce((s, i) => s + (i.final_line_price || 0), 0)
        if (itemsSubtotal <= 0 || discAmount <= 0) return null

        const ratio = discAmount / itemsSubtotal
        const cleanPercent = Math.round(ratio * 100)
        const isPercentage = Math.abs(ratio - cleanPercent / 100) < 0.002

        return {
            canUse: "true",
            items: { __typename: "AllDiscountItems" },
            value: isPercentage
                ? { __typename: "DiscountPercentage", percentage: cleanPercent / 100 }
                : { __typename: "DiscountAmount", amount: { amount: discAmount / 100 } }
        }
    }

    /**
     * _probeDiscountIsolated – NDK 2026-10-16: con el carrito vacío Shopify no
     * calcula el descuento. Antes se añadía una unidad al carrito REAL de la clienta
     * (/cart/add.js + /cart/change.js) y Shopify lo emitía como product_added_to_cart
     * → «Added to Cart» falso en Klaviyo (sacaba a las suscritas del pop-up de la
     * bienvenida) y en los píxeles de anuncios.
     *
     * Ahora: carrito desechable con la Storefront API (cartCreate, sin token), lanzado
     * desde un Web Worker. El Worker es imprescindible: el Web Pixels Manager parchea
     * window.fetch y XHR de la página y, si ve `extensions.cart_changelog.items_added`
     * en una respuesta de /api/…/graphql.json, también emite product_added_to_cart.
     * El fetch del Worker no pasa por ese parche. Nunca se toca el carrito de la clienta.
     *
     * Devuelve { status: 'ok', data } | { status: 'not_applicable' } | { status: 'error' }.
     * 'not_applicable' = Shopify dice que el código no vale con un artículo dentro
     * (inexistente, caducado o no aplicable a ese producto).
     */
    async _probeDiscountIsolated(code) {
        try {
            if (!code || typeof Worker === 'undefined' || typeof Blob === 'undefined') return { status: 'error' }

            // 1. Variante: la de la página (PDP) o, si no hay, el primer producto del catálogo
            let variantId = null
            const variantEl = document.querySelector('[data-variant-id]')
            if (variantEl) {
                variantId = variantEl.getAttribute('data-variant-id')
            }
            if (!variantId) {
                const prodRes = await fetch('/products.json?limit=1')
                const prodData = await prodRes.json()
                if (prodData.products?.[0]?.variants?.[0]?.id) {
                    variantId = prodData.products[0].variants[0].id
                }
            }
            if (!variantId) return { status: 'error' }

            // 2. cartCreate en un Worker (carrito aparte, sin cookies de la clienta)
            const query = 'mutation($i:CartInput!){cartCreate(input:$i){cart{cost{subtotalAmount{amount}} discountCodes{code applicable} discountAllocations{__typename discountedAmount{amount} ... on CartCodeDiscountAllocation{code}}} userErrors{message}}}'
            const body = JSON.stringify({
                query: query,
                variables: { i: { lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: 1 }], discountCodes: [code] } }
            })
            const workerSrc = 'onmessage=function(e){fetch(e.data.url,{method:"POST",credentials:"omit",headers:{"Content-Type":"application/json"},body:e.data.body})' +
                '.then(function(r){return r.json()}).then(function(j){postMessage({ok:true,json:j})})' +
                '.catch(function(err){postMessage({ok:false})})}'
            const blobUrl = URL.createObjectURL(new Blob([workerSrc], { type: 'text/javascript' }))
            const worker = new Worker(blobUrl)
            const msg = await new Promise(resolve => {
                const timer = setTimeout(() => resolve({ ok: false }), 8000)
                worker.onmessage = e => { clearTimeout(timer); resolve(e.data) }
                worker.onerror = () => { clearTimeout(timer); resolve({ ok: false }) }
                worker.postMessage({ url: window.location.origin + '/api/2025-07/graphql.json', body: body })
            })
            worker.terminate()
            URL.revokeObjectURL(blobUrl)

            const cart = msg && msg.ok && msg.json && msg.json.data && msg.json.data.cartCreate && msg.json.data.cartCreate.cart
            if (!cart) return { status: 'error' }

            // 3. ¿Lo acepta Shopify con un artículo dentro?
            const upper = code.toUpperCase()
            const entry = (cart.discountCodes || []).find(dc => (dc.code || '').toUpperCase() === upper)
            if (!entry || entry.applicable === false) return { status: 'not_applicable' }

            // 4. Mismo formato que _parseCartDiscount (descuento a nivel de pedido, en céntimos)
            const discAmount = Math.round((cart.discountAllocations || [])
                .filter(a => a.__typename === 'CartCodeDiscountAllocation' && (a.code || '').toUpperCase() === upper)
                .reduce((s, a) => s + parseFloat(a.discountedAmount?.amount || 0), 0) * 100)
            const itemsSubtotal = Math.round(parseFloat(cart.cost?.subtotalAmount?.amount || 0) * 100)
            const data = this._parseCartDiscount({
                cart_level_discount_applications: discAmount > 0 ? [{ total_allocated_amount: discAmount }] : [],
                items: [{ final_line_price: itemsSubtotal }]
            })
            // Aplicable pero sin importe de pedido (p. ej. solo envío o solo ciertos productos): no se pinta, como hoy
            return data ? { status: 'ok', data: data } : { status: 'error' }
        } catch (e) {
            return { status: 'error' }
        }
    }

    // NDK 2026-10-16: caché de coupon_data por código, para no crear un carrito desechable en cada página
    _readCachedDiscount(code, maxAgeMs) {
        try {
            const cached = JSON.parse(localStorage.getItem("coupon_data") || 'null')
            if (!cached || !cached.value) return null
            if (code && cached.code && cached.code !== code) return null
            if (maxAgeMs && (!cached.ts || Date.now() - cached.ts > maxAgeMs)) return null
            return cached
        } catch (e) {
            return null
        }
    }

    _saveCachedDiscount(code, data) {
        try {
            localStorage.setItem("coupon_data", JSON.stringify(Object.assign({}, data, { code: code, ts: Date.now() })))
        } catch (e) {}
    }

    _clearCoupon() {
        localStorage.removeItem("coupon")
        localStorage.removeItem("coupon_data")
        localStorage.removeItem("discount_code")
        localStorage.removeItem("sc:discount.code")
        document.cookie = 'discount_code=; path=/; max-age=0'
        this.discountCode = null
        this.discountData = null
    }

    async getDiscount(){
        try{
            // NDK 2026-08: rediseño conservador.
            // Antes: re-aplicaba /discount/ POR CADA código en CADA page load y luego
            // reducía la cookie al PRIMER código aplicable (rompía multi-código FLASH+INVIO).
            // Ahora: lee el carrito primero, solo aplica los códigos que a la sesión le
            // faltan, y persiste TODOS los aplicables (CSV), filtrando junk (TBN_*).
            const rawCode = this.discountCode
            const codes = rawCode.split(',')
                .map(function(c) { return c.trim().toUpperCase(); })
                .filter((c, i, arr) => c.length > 0 && !this._isJunk(c) && arr.indexOf(c) === i)

            let cart = await (await fetch('/cart.js')).json()
            const sessionCodes = (cart.discount_codes || []).map(function(dc) { return (dc.code || '').toUpperCase(); })
            const missing = codes.filter(function(c) { return sessionCodes.indexOf(c) === -1; })

            if (missing.length > 0) {
                for (var ci = 0; ci < missing.length; ci++) {
                    await fetch('/discount/' + encodeURIComponent(missing[ci]), { method: 'GET', redirect: 'manual' }).catch(function(){})
                }
                await new Promise(function(r) { setTimeout(r, 200); })
                cart = await (await fetch('/cart.js')).json()
            }

            // All applicable codes from Shopify (junk-filtered)
            const applicableCodes = (cart.discount_codes || [])
                .filter(dc => dc.code && dc.applicable !== false && !this._isJunk(dc.code))
                .map(function(dc) { return dc.code.toUpperCase(); })

            // NDK 2026-10-16: con el carrito VACÍO Shopify devuelve todos los códigos con
            // "applicable": false (no hay nada a lo que aplicarlos) — eso no significa que no
            // valgan. Antes se borraba el cupón aquí y desde la 2ª página no se veían los
            // precios con descuento. Ahora se conserva y se valida aparte (carrito desechable):
            // solo se borra si Shopify lo rechaza con un artículo dentro.
            if (applicableCodes.length === 0 && cart.item_count === 0 && codes.length > 0) {
                const valid = []
                let painted = false
                for (let i = 0; i < codes.length; i++) {
                    const code = codes[i]
                    let data = painted ? null : this._readCachedDiscount(code, 60 * 60 * 1000)
                    if (!data && !painted) {
                        const probe = await this._probeDiscountIsolated(code)
                        if (probe.status === 'not_applicable') continue // inexistente o caducado
                        if (probe.status === 'ok') {
                            data = probe.data
                            this._saveCachedDiscount(code, data)
                        } else {
                            data = this._readCachedDiscount(code, 0) // fallo de red: último cálculo de ESTE código
                        }
                    }
                    valid.push(code)
                    if (data && !painted) {
                        this.discountCode = code
                        this.discountData = data
                        painted = true
                    }
                }
                if (valid.length === 0) {
                    this._clearCoupon()
                    return
                }
                const keepCsv = valid.join(',')
                localStorage.setItem("coupon", keepCsv)
                document.cookie = 'discount_code=' + encodeURIComponent(keepCsv) + '; path=/; max-age=2592000'
                if (painted) {
                    this.initProductsHandler()
                } else {
                    this.discountCode = valid[0]
                }
                return
            }

            // Con artículos en el carrito y ningún código aplicable: de verdad no vale → limpiar
            if (applicableCodes.length === 0) {
                this._clearCoupon()
                return
            }

            // PDP painter usa el primero (igual que antes); la cookie conserva TODOS
            this.discountCode = applicableCodes[0]
            const csv = applicableCodes.join(',')
            localStorage.setItem("coupon", csv)
            document.cookie = 'discount_code=' + encodeURIComponent(csv) + '; path=/; max-age=2592000'

            let parsed = this._parseCartDiscount(cart)

            // Cart is empty or discount not calculable — carrito desechable (sin tocar el de la clienta)
            if (!parsed && cart.item_count === 0) {
                const probe = await this._probeDiscountIsolated(this.discountCode)
                if (probe.status === 'ok') parsed = probe.data
            }

            if (parsed) {
                this.discountData = parsed
                this._saveCachedDiscount(this.discountCode, this.discountData)
                this.initProductsHandler()
                return
            }

            // Still nothing — último cálculo guardado de ESTE código
            const cached = this._readCachedDiscount(this.discountCode, 0)
            if (cached) {
                this.discountData = cached
                this.initProductsHandler()
                return
            }
            localStorage.setItem("coupon", "")

        }catch (error) {
        }
    }

    initProductsHandler(){
        const { items: {__typename: discountItemsType, products} } = this.discountData
        const productsSelector = discountItemsType === "AllDiscountItems" ? '[data-product-handle]'
            : products.nodes.map(({handle}) => `[data-product-handle=${handle}]`).join(',')

        this.productWrappers = document.querySelectorAll(productsSelector)

        if(!this.productWrappers) return

        this.updatePrices(this.productWrappers)
        this.updateVariantCards()

        if (!this._handlerSetup) {
            this._handlerSetup = true
            this.productsHandler()
        }
    }

    productsHandler(){
        document.addEventListener('changed_variant', ({detail: {section}}) =>{
            this.updatePrices(section.querySelectorAll(`[data-price-container]`))
        })
    }

    updatePrices(productsWrappers){
        const { value: {__typename: discountType} } = this.discountData
        const discountValue = discountType === "DiscountPercentage" ? this.discountData.value.percentage
            : this.discountData.value.amount.amount * 100

        productsWrappers.forEach(wrapper => {
            wrapper.querySelectorAll("[data-price]").forEach(priceWrapper => {
                if (priceWrapper.dataset.couponApplied === this.discountCode) return
                
                if (!priceWrapper.dataset.originalHtml) {
                    priceWrapper.dataset.originalHtml = priceWrapper.innerHTML
                }
                
                const { priceFormat, price, comparePrice } = priceWrapper.dataset
                const [withCurrency, pattern, haveSaving, insetFormat, savingFormat] = priceFormat?.split("|")
                if(!price) return

                let updatePrice = discountType === "DiscountPercentage" ?
                    price * (1 - discountValue) :
                    price - discountValue

                if(savingFormat === "discount_amount"){
                    updatePrice = (comparePrice ? comparePrice : price) - updatePrice
                }

                const formatted_price = window.Shopify.formatMoney(updatePrice, withCurrency)
                if(insetFormat === "append"){
                    priceWrapper.innerHTML += this.buildPrice(formatted_price, pattern)
                } else if(insetFormat === "prepend"){
                    priceWrapper.innerHTML = this.buildPrice(formatted_price, pattern) + priceWrapper.innerHTML
                } else if(insetFormat === "insert"){
                    priceWrapper.innerHTML = this.buildPrice(formatted_price, pattern)
                }

                if(haveSaving){
                    const savingPercent = (((comparePrice ? comparePrice : price) - updatePrice) / (comparePrice ? comparePrice : price) * 100).toFixed(0)
                    priceWrapper.innerHTML += this.buildPrice(savingPercent, savingFormat)
                }
                
                priceWrapper.dataset.couponApplied = this.discountCode
            })
        })
    }

    // v44: Update variant cards with coupon info
    // Shows coupon badge, updates daily cost, shows sale-strike price
    updateVariantCards() {
        if (!this.discountData) return

        const { value: { __typename: discountType } } = this.discountData
        const discountValue = discountType === "DiscountPercentage"
            ? this.discountData.value.percentage
            : this.discountData.value.amount.amount * 100

        const discountPercent = discountType === "DiscountPercentage"
            ? Math.round(discountValue * 100)
            : null

        document.querySelectorAll('.selector-variant__wrapper > label[data-variant-id]').forEach(label => {
            if (label.dataset.couponCardApplied === this.discountCode) return
            label.dataset.couponCardApplied = this.discountCode

            const variantPrice = parseInt(label.dataset.variantPrice) || 0
            const variantComparePrice = parseInt(label.dataset.variantComparePrice) || 0
            const variantDays = parseInt(label.dataset.variantDays) || 0

            // Calculate coupon price
            let couponPrice
            if (discountType === "DiscountPercentage") {
                couponPrice = variantPrice * (1 - discountValue)
            } else {
                couponPrice = variantPrice - discountValue
            }
            couponPrice = Math.round(couponPrice)

            // Calculate total discount percentage (from original/compare price to coupon price)
            const originalPrice = variantComparePrice > 0 ? variantComparePrice : variantPrice
            const totalDiscountPercent = Math.round(((originalPrice - couponPrice) / originalPrice) * 100)

            // --- Show coupon badge ---
            const couponBadge = label.querySelector('.variant__coupon-badge')
            if (couponBadge) {
                couponBadge.textContent = `CUPÓN -${totalDiscountPercent}%`
                couponBadge.style.display = ''
            }

            // --- Show sale-strike (current price becomes strikethrough) ---
            const saleStrike = label.querySelector('.variant__price-sale-strike')
            if (saleStrike) {
                saleStrike.style.display = ''
            }

            // --- Update main price to coupon price ---
            const priceMain = label.querySelector('.variant__price-main')
            if (priceMain) {
                const formatted = window.Shopify.formatMoney(couponPrice, '')
                const parts = formatted.replace('€', '').trim().split(',')
                const intPart = parts[0] || ''
                const centsPart = parts[1] || '00'
                priceMain.innerHTML = `<span class="variant__price-int">${intPart}</span><span class="variant__price-cents">,${centsPart}€</span>`
            }

            // --- Update daily cost ---
            const dailyCostEl = label.querySelector('.variant__daily-cost')
            if (dailyCostEl && variantDays > 0) {
                if (!dailyCostEl.dataset.originalText) {
                    dailyCostEl.dataset.originalText = dailyCostEl.textContent
                }
                const dailyCoupon = Math.round(couponPrice / variantDays)
                dailyCostEl.textContent = `SALE A ${window.Shopify.formatMoney(dailyCoupon, '')} / DÍA`
            }
        })
    }

    revertPrices() {
        document.querySelectorAll('[data-coupon-applied]').forEach(el => {
            if (el.dataset.originalHtml) {
                el.innerHTML = el.dataset.originalHtml
                delete el.dataset.originalHtml
            }
            delete el.dataset.couponApplied
        })

        document.querySelectorAll('.selector-variant__wrapper > label[data-coupon-card-applied]').forEach(label => {
            delete label.dataset.couponCardApplied

            const couponBadge = label.querySelector('.variant__coupon-badge')
            if (couponBadge) {
                couponBadge.style.display = 'none'
                couponBadge.textContent = ''
            }

            const saleStrike = label.querySelector('.variant__price-sale-strike')
            if (saleStrike) {
                saleStrike.style.display = 'none'
            }

            // Restore original main price from data attributes
            const variantPrice = parseInt(label.dataset.variantPrice) || 0
            const priceMain = label.querySelector('.variant__price-main')
            if (priceMain && variantPrice) {
                const formatted = window.Shopify.formatMoney(variantPrice, '')
                const parts = formatted.replace('€', '').trim().split(',')
                const intPart = parts[0] || ''
                const centsPart = parts[1] || '00'
                priceMain.innerHTML = `<span class="variant__price-int">${intPart}</span><span class="variant__price-cents">,${centsPart}€</span>`
            }

            const dailyCostEl = label.querySelector('.variant__daily-cost')
            if (dailyCostEl && dailyCostEl.dataset.originalText) {
                dailyCostEl.textContent = dailyCostEl.dataset.originalText
                delete dailyCostEl.dataset.originalText
            }
        })

        this.discountData = null
        this.discountCode = null
    }

    async applyNow(code) {
        code = String(code || '').trim().toUpperCase()
        if (!code || this._isJunk(code)) return
        this.discountCode = code
        // NDK 2026-08: merge en la CSV existente en vez de sobreescribir — antes esta
        // escritura pisaba los códigos multi aplicados por el usuario (vía Klaviyo, etc.)
        const existingRaw = this.getCookie("discount_code") || (function(){ try { return localStorage.getItem("coupon") || ''; } catch(e) { return ''; } })()
        const merged = existingRaw.split(',')
            .map(function(c) { return c.trim().toUpperCase(); })
            .filter((c, i, arr) => c.length > 0 && !this._isJunk(c) && arr.indexOf(c) === i)
        if (merged.indexOf(code) === -1) merged.push(code)
        const csv = merged.join(',')
        document.cookie = 'discount_code=' + encodeURIComponent(csv) + '; path=/; max-age=2592000'
        localStorage.setItem("coupon", csv)
        
        try {
            await fetch('/discount/' + encodeURIComponent(code), { method: 'GET', redirect: 'manual' }).catch(() => {})
            await new Promise(r => setTimeout(r, 200))
            
            const cart = await (await fetch('/cart.js')).json()
            
            let parsed = this._parseCartDiscount(cart)

            // Cart is empty — carrito desechable (NDK 2026-10-16: sin tocar el de la clienta)
            if (!parsed && cart.item_count === 0) {
                const probe = await this._probeDiscountIsolated(code)
                if (probe.status === 'ok') {
                    parsed = probe.data
                } else if (probe.status === 'not_applicable') {
                    // Código inexistente o caducado: fuera de la CSV y no se pinta nada
                    const rest = merged.filter(function(c) { return c !== code; })
                    if (rest.length > 0) {
                        document.cookie = 'discount_code=' + encodeURIComponent(rest.join(',')) + '; path=/; max-age=2592000'
                        localStorage.setItem("coupon", rest.join(','))
                    } else {
                        document.cookie = 'discount_code=; path=/; max-age=0'
                        localStorage.removeItem("coupon")
                    }
                    return
                }
            }

            if (parsed) {
                this._saveCachedDiscount(code, parsed)
            } else {
                // Last resort: último cálculo guardado de ESTE código
                parsed = this._readCachedDiscount(code, 0)
            }

            if (parsed) {
                this.discountData = parsed
                this.initProductsHandler()
            }
        } catch(e) {}
    }

    getCookie(name) {
        const match = document.cookie.match(new RegExp('(^|;)\\s*' + name + '=([^;]*)'))
        return match ? decodeURIComponent(match[2]) : null
    }

    // NDK 2026-08: mismo criterio que _isJunkCode de utcart-v2.js — mantener en sync
    _isJunk(code) {
        if (!code) return true
        const u = String(code).toUpperCase()
        return u === 'TBN_REMOVE_DISCOUNT_CODES' || u.indexOf('TBN_REMOVE') === 0
    }

    buildPrice(money, type){
        switch (type){
            case "separated": {
                const [intPrice, fractionalPrice] = money.split(",")
                return this.markupPatterns.price.outerHTML.replace('{intPrice}', intPrice)
                    .replace('{fractionalPrice}', fractionalPrice)
                break
            }
            case "inline": {
                return money
                break
            }
            case "covered-inline": {
                return `<span>${money}</span>`
                break
            }
            case "coupon": {
                return this.markupPatterns.savingCoupon.outerHTML.replace('{percent}', money)
                break
            }
            case "badge": {
                return this.markupPatterns.savingBadge.outerHTML.replace('{percent}', money)
                break
            }
        }
    }

}
window.discountCoupon = new DiscountCoupon()

// === Klaviyo popup discount auto-apply ===
window.addEventListener("klaviyoForms", function(e) {
    if (e.detail.type === 'close' || e.detail.type === 'submit') {
        let foundCode = ''
        
        // Strategy 1: Find a button inside the Klaviyo form whose text looks like a coupon code
        // Coupon codes are short (3-15 chars), uppercase alphanumeric, inside a button
        // Exclude known non-code buttons (close, submit/CTA which are longer phrases)
        var klavForm = document.querySelector('.klaviyo-form, [data-testid*="klaviyo-form"]')
        if (klavForm) {
            klavForm.querySelectorAll('button').forEach(function(btn) {
                var text = btn.textContent.trim()
                // Skip close buttons and long CTA buttons (> 15 chars are phrases, not codes)
                if (btn.classList.contains('klaviyo-close-form')) return
                if (text.length > 15) return
                // Match coupon code pattern: 3-15 alphanumeric chars (with optional hyphens/underscores)
                if (/^[A-Z0-9][A-Z0-9_-]{1,14}$/i.test(text) && !foundCode) {
                    foundCode = text.toUpperCase()
                }
            })
        }

        // Strategy 2 fallback: check for a dedicated coupon element with data attribute
        if (!foundCode) {
            document.querySelectorAll('[data-coupon], [data-testid*="coupon"]').forEach(function(el) {
                var text = el.textContent.trim()
                if (/^[A-Z0-9_-]{3,15}$/i.test(text) && !foundCode) {
                    foundCode = text.toUpperCase()
                }
            })
        }
        
        if (foundCode && window.discountCoupon) {
            window.discountCoupon.applyNow(foundCode)
        }
    }
})
